import { Injectable } from '@angular/core';
import { CalculationKeynameEnum } from '../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import {
  CalculationCreationOptions,
} from '../../../../../../../common/src/options/calculations/calculation-creation.options';

@Injectable()
export class CalculationKeynameOptionsFactory {
  create(calculationKeynameEnum: CalculationKeynameEnum): CalculationCreationOptions | undefined {
    switch (calculationKeynameEnum) {
      case CalculationKeynameEnum.Section84_1: {
        const options = new CalculationCreationOptions();
        options.calculationKeyname = CalculationKeynameEnum.Section84_1;
        options.title = '';
        return options;
      }
    }

    return undefined;
  }
}
